import { object, string, mixed } from "./";
import { phoneSchema } from "./phone";

export const authSchema = object().shape({
  strategy: mixed(),
  email: mixed().when("strategy", (strategy, schema) => {
    return strategy === "phone" ? schema : string().required();
  }),
  password: string().required(),
  phone: mixed().when("strategy", (strategy, schema) => {
    return strategy === "email" ? schema : phoneSchema.required();
  }),
});
